// @core/api/endpoints/document/find_templates_for_entity.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ListDocumentTemplatesResponse,
} from '../../../types/document';

const BASE_PATH = '/document';

/**
 * Find templates for entity
 * Returns document templates available for the specified entity, ordered by binding specificity.
 */
export async function FindTemplatesForEntity(
  entity_type: string,
  entity_id: string,
  options?: RequestOptions
): Promise<ListDocumentTemplatesResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/documents/:entity_type/:entity_id/templates`;
  requestPath = requestPath.replace(':entity_type', encodeURIComponent(entity_type));
  requestPath = requestPath.replace(':entity_id', encodeURIComponent(entity_id));
  const requestOptions = options;
  return client.get<ListDocumentTemplatesResponse>(requestPath, { ...requestOptions });
}
